import { CheckCircle2 } from "lucide-react";

/**
 * Compact reassurance strip — 4 USPs above the footer.
 * Reinforces the direct-landlord positioning across all public pages.
 */
const ITEMS = [
  "Propriétaire-bailleur direct",
  "Sans agence, sans commission",
  "Photovoltaïque intégré",
  "Visite sous 5 jours",
];

export const TrustStrip = () => (
  <div
    className="bg-[#FFC107] border-y-2 border-slate-900 py-4 px-6"
    data-testid="trust-strip"
  >
    <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center gap-2 text-slate-900">
          <CheckCircle2 className="w-4 h-4 shrink-0" strokeWidth={2.5} />
          <span className="text-xs md:text-sm font-bold uppercase tracking-wide">{t}</span>
        </div>
      ))}
    </div>
  </div>
);

export default TrustStrip;
